import { render, staticRenderFns } from "./PaypalRate.vue?vue&type=template&id=57a529b3"
import script from "./PaypalRate.vue?vue&type=script&lang=js"
export * from "./PaypalRate.vue?vue&type=script&lang=js"
import style0 from "./PaypalRate.vue?vue&type=style&index=0&id=57a529b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports